import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { CityViewPage } from '../components/CityViewPage'
import {
  actionCreators,
  ICityViewState,
  selectCity,
  selectError,
  selectIsLoading,
  selectIsUpdatingDemographics,
  selectPermissions,
} from '../modules/cityView'

export default connect(
  createStructuredSelector<ApplicationState, ICityViewState>({
    city: selectCity(),
    error: selectError(),
    isLoading: selectIsLoading(),
    isUpdatingDemographics: selectIsUpdatingDemographics(),
    permissions: selectPermissions(),
  }),
  actionCreators,
)(CityViewPage)
